import { Transaction, TransactionState } from './types';

export const transactions = (state: TransactionState) => (): Transaction[] => {
  return state.transactions;
};
